module.exports = __webpack_public_path__ + "img/E6.eb90800d.svg";